import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Modal } from '@grandvisionhq/common';
import { appendQueryParamToUrl } from '@grandvisionhq/utils';
import { MiniCart } from '../layouts/MiniCart.js';
import { useMiniCartListener } from '../utils/event.js';

var ModalContainer = (_param)=>{
    var { modal  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "modal"
    ]);
    const [lineItems, setLineItems] = React.useState(undefined);
    const [linksWithCardId, setLinksWithCardId] = React.useState({
        cart: undefined,
        checkout: undefined
    });
    const { links  } = rest, restWithoutLinks = swcHelpers.objectWithoutProperties(rest, [
        "links"
    ]);
    useMiniCartListener((event)=>{
        const { cartId , cartHash , type  } = event.detail;
        if (!lineItems || type === 'updated') {
            setLinksWithCardId({
                cart: (links === null || links === void 0 ? void 0 : links.cart) ? appendQueryParamToUrl(links.cart, swcHelpers.objectSpread({}, cartId ? {
                    cartId
                } : null, cartHash ? {
                    cartHash
                } : null)) : undefined,
                checkout: (links === null || links === void 0 ? void 0 : links.checkout) ? appendQueryParamToUrl(links.checkout, swcHelpers.objectSpread({}, cartId ? {
                    cartId
                } : null, cartHash ? {
                    cartHash
                } : null)) : undefined
            });
            setLineItems(event.detail.lineItems);
        }
    });
    const handleClose = ()=>{
        setLineItems(undefined);
        (modal === null || modal === void 0 ? void 0 : modal.onModalClose) && modal.onModalClose();
    };
    var ref, ref1;
    return /*#__PURE__*/ React.createElement(Modal, swcHelpers.extends({}, modal, {
        className: classnames('mini-cart-v2', modal === null || modal === void 0 ? void 0 : modal.className),
        "data-t": "mini-cart-v2",
        isOpen: (ref = !!lineItems || (modal === null || modal === void 0 ? void 0 : modal.isOpen)) !== null && ref !== void 0 ? ref : false,
        onModalClose: handleClose,
        showIcon: (ref1 = modal === null || modal === void 0 ? void 0 : modal.showIcon) !== null && ref1 !== void 0 ? ref1 : true
    }), lineItems ? /*#__PURE__*/ React.createElement(MiniCart, swcHelpers.extends({
        lineItems: lineItems,
        links: linksWithCardId
    }, restWithoutLinks)) : null);
};

export { ModalContainer };
//# sourceMappingURL=ModalContainer.js.map
